var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-card',{attrs:{"max-width":"400","flat":""}},[_c('v-card-text',[_c('p',[_vm._v("\n          Liste des projets\n        ")])]),_c('elac-tenants-list',{on:{"select":_vm.select}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }